<template>
  <section data-label="share">
    <div class="share-wx" v-show="isShowtips" v-on:click="showView = false" style="z-index:10000;" id="share-wx-tips">
      <img src="../static/img/share-guide.png" alt />
      <p>
        请点击右上角将它发送给
        <br />指定朋友或者分享到朋友圈
      </p>
    </div>
    <!--家家亲友团联名卡图片-->
    <section v-show="isShowIamge">
      <div class="share-wx" style="z-index:8;" v-on:click="showView = false"></div>
      <div class="share-lmk active" id="imgShrea">
        <img v-bind:src="shareImageUrl" alt />
        <p>
          长按上图发送给好友
          <em>/</em>保存图片后转发朋友圈
        </p>
      </div>
    </section>
    <!--家家亲友团联名卡图片-->
  </section>
</template>
<script>
import Environment from "../service/environment.service.js";
export default {
  name: "share",
  props: {
    title: {
      type: String
    },
    link: {
      type: String
    },
    imgUrl: {
      type: String
    },
    desc: {
      type: String
    },
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: Number,
      required: false,
      default: 3
    },
    platformActivityId: {
      type: Number,
      required: false,
      default: 0
    },
    originalImg: {
      type: Boolean,
      required: false,
      default: false
    },
    businessLineId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      shareImageUrl: "",
      showView: false
    };
  },
  computed: {
    isShowtips: function () {
      return this.showView && this.type !== 4;
    },
    isShowIamge: function () {
      return this.showView && this.type === 4;
    }
  },
  created: function () {
    if (this.link) {
      this.execute();
    }
  },
  methods: {
    execute: function () {
      if (this.type === 3) {
        this.setLinkShare();
      } else if (this.type === 4) {
        this.setImageShare();
      }
    },
    setWeixinShare: function () {
      let shareImg =
        "https://j2.autoimg.cn/financedfs/g24/M0A/C8/F1/autohomecar__Chxky2Tdt2iANtLiAABI5Rq0ntU689.png";
      const that = this;
      // etc金融的分享指定图标
      if (that.businessLineId === 1408) {
        shareImg = "https://x.autoimg.cn/j/m/images/etc.png";
      } else if (that.businessLineId == 2002) {
        shareImg = "https://fs.autohome.com.cn/ahoh_views/mall/images/laxin-share.png";
      }
      Environment.share({
        webpageURL: that.link,
        title: that.title,
        iconURL: shareImg,
        description: that.desc
      });
    },
    /**
    设置图片分享
     */
    setImageShare: function () {
      let requestUrl = encodeURIComponent(this.link);
      let imageUrl =
        "/ShareImage/Generate?url=" +
        requestUrl +
        "&platformActivityId=" +
        this.platformActivityId;
      this.shareImageUrl = imageUrl;
      this.setWeixinShare();
    },
    /*
    设置链接分享
    */
    setLinkShare: function () {
      this.setWeixinShare();
    },
    shareClick(shareWXType) {
      const that = this;
      let shareImg =
        "https://j2.autoimg.cn/financedfs/g24/M0A/C8/F1/autohomecar__Chxky2Tdt2iANtLiAABI5Rq0ntU689.png";
      if (that.businessLineId === 2002) {
        shareImg = "https://fs.autohome.com.cn/ahoh_views/mall/images/laxin-share.png";
      }
      Environment.shareClick({
        webpageURL: that.link,
        title: that.title,
        iconURL: shareImg,
        description: that.desc,
        shareWXType: shareWXType
      });
    }
  },
  watch: {
    link: function (val, oldVal) {
      this.execute();
    },
    show: function (val, oldVal) {
      this.showView = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/share.vue